<script>
export default {};
</script>

<template>
  <div
    class="flex items-center justify-center px-8 h-28 w-full bg-surface-hover text-muted"
  >
    <fluent-icon icon="document-error" size="32" />
    <p class="mb-0 text-muted">
      {{ $t('COMPONENTS.FILE_BUBBLE.INSTAGRAM_STORY_UNAVAILABLE') }}
    </p>
  </div>
</template>
